import React from "react";
import { useModules } from "../context/ModulesContext";

interface OrgOverviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  org: {
    companyName: string;
    displayName: string;
    planName: string;
    planFeatures: Record<string, { enabled: boolean }>;
    overrideFeatures: Record<string, { enabled: boolean }>;
    lastUpdated: string;
    defaultModule?: string;
  } | null;
  addOns: { key: string; name: string; description: string; category: string }[];
}

export default function OrgOverviewModal({
  isOpen,
  onClose,
  org,
  addOns: _addOns,
}: OrgOverviewModalProps) {
  const { approvedKeys, labelFor } = useModules();

  if (!isOpen || !org) return null;

  const isEffectivelyOn = (key: string): boolean => {
    const override = org.overrideFeatures?.[key];
    if (override !== undefined) return override.enabled;
    return org.planFeatures?.[key]?.enabled === true;
  };

  const enabledModules = approvedKeys.filter(isEffectivelyOn);

  return (
    <div className="smrtdocs-modal-overlay">
      <div className="smrtdocs-modal" style={{ width: "480px" }}>
        <div className="smrtdocs-modal-header">
          <h2 style={{ margin: 0, fontSize: "1rem" }}>Organization Overview</h2>
        </div>
        <div className="smrtdocs-modal-body">
          <p style={{ margin: "0 0 8px", fontSize: "0.9rem" }}>
            <strong>Name:</strong> {org.companyName}
          </p>
          {org.displayName && (
            <p style={{ margin: "0 0 8px", fontSize: "0.9rem" }}>
              <strong>Display Name:</strong> {org.displayName}
            </p>
          )}
          {org.planName && (
            <p style={{ margin: "0 0 8px", fontSize: "0.9rem" }}>
              <strong>Plan:</strong> {org.planName}
            </p>
          )}
          {org.lastUpdated && (
            <p style={{ margin: "0 0 16px", fontSize: "0.9rem" }}>
              <strong>Last Updated:</strong> {org.lastUpdated}
            </p>
          )}

          <p style={{ margin: "0 0 6px", fontSize: "0.9rem", fontWeight: 600 }}>
            Features enabled for this organization:
          </p>
          {enabledModules.length === 0 ? (
            <p style={{ margin: "0 0 20px", fontSize: "0.85rem", color: "#aaa" }}>
              No features are enabled.
            </p>
          ) : (
            <ul style={{ margin: "0 0 20px", paddingLeft: "20px", fontSize: "0.9rem", lineHeight: 1.6 }}>
              {enabledModules.map((key) => {
                const isDefault = key === org.defaultModule;
                return (
                  <li key={key}>
                    {isDefault ? (
                      <span
                        title="Default Module"
                        style={{
                          fontSize: "0.8rem",
                          background: "#1a3a2a",
                          color: "#4caf50",
                          border: "1px solid #4caf50",
                          padding: "4px 10px",
                          borderRadius: "4px",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {labelFor(key)} ★
                      </span>
                    ) : (
                      labelFor(key)
                    )}
                  </li>
                );
              })}
            </ul>
          )}

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button className="btn-cancel" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
}
